import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { PDFResponse } from '../models/pdf.model';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Injectable({
  providedIn: 'root',
})
export class PdfService extends UtilsBaseApiService<PdfService> {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('orcamentopdf', injector, environment.BASE_API_URL);
  }

  getPdf(id: number | string): Observable<PDFResponse[]> {
    const QUERY_STRING = 'SEQ_PEDIDO=' + id;
    return this.httpClient.get<PDFResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}?${QUERY_STRING}`
    );
  }
}
